import {useAppSelector} from "../../../redux/hooks";
import {isDefined} from "../../../util/is-type";
import {myProfileStore} from "../../../redux/my-profile/myProfileStore";

export interface IWhenUserLogicProps {
  isMember?: boolean;
  membershipGiveSongAccess?: boolean;
}

export interface IWhenUserLogic {
  isAllowed: boolean;
}

export const useWhenUserLogic = ({isMember, membershipGiveSongAccess}: IWhenUserLogicProps): IWhenUserLogic => {
  const myProfileIsMember = useAppSelector(myProfileStore.getMyProfileMembershipIsMember);
  const myProfileMembershipIsSongLibraryAccessible = useAppSelector(myProfileStore.getMyProfileMembershipIsSongLibraryAccessible);

  let isAllowed: boolean = true;

  if (isDefined<boolean>(isMember)){
    isAllowed = isAllowed && isMember === myProfileIsMember;
  }

  if (isDefined<boolean>(membershipGiveSongAccess)){
    isAllowed = isAllowed && membershipGiveSongAccess === myProfileMembershipIsSongLibraryAccessible;
  }

  return {
    isAllowed,
  };
}
